import { KPI_VALUE_CLASSIC } from '@/utils/hooks/format/useFormatKpiValue';

import { colors } from '@/lib/analytics/colors';
import { ORIENTATION_VERTICAL } from '@/lib/gridElements/orientation';
import { SIZE_33 } from '@/lib/gridElements/size';

import { KPIDefault } from '@/components/base/Kpi/KpiDefault';
import { DefaultLoader } from '@/components/base/Kpi/KpiLoader';

export const totalPostsViewsConfig = {
    name: 'kpi.instagram.views',
    id: 'views',
    mergedData: true,
    tooltip: 'kpi.instagram.tooltip_total_posts_views',
    icon: {
        name: 'impressions',
        style: colors.purple
    },
    data_format: KPI_VALUE_CLASSIC,
    size: SIZE_33,
    type: 'kpi',
    growth_tooltip: {
        up: 'analytics:kpi.growth_tooltip.up',
        down: 'analytics:kpi.growth_tooltip.down',
        still: 'analytics:kpi.growth_tooltip.still'
    },
    loader: DefaultLoader,
    orientation: ORIENTATION_VERTICAL,
    element: KPIDefault
};
